export default {
    _prefix: "ScoreOverview",
    title: {
        scaled: "Scaled Scores",
        unscaled: "Scores",
        totalScoreLabel: "Score: ",
        criticalScoreLabel: "Critical Score: ",
        npsScoreLabel: "NPS: ",
        npsScoreEmptyLabel: "N/A",
    },
    criticalPercentage: "{{percentage}} ({{criticalPercentage}})",
    expandScores: "Expand score details",
};
